import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import Dev from './Dev';
import styles from './styles';

function mapStateToProps(state) {
  const { isLoading, data } = state.dev;
  return {
    isLoading,
    data,
  };
}

const Styled = withStyles(styles)(Dev);

export default connect(
  mapStateToProps,
)(Styled);
